var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#036AB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.125 30.375H40.5689L35.875 25.6811C35.6206 25.4246 35.3177 25.2213 34.984 25.0829C34.6503 24.9445 34.2924 24.8739 33.9311 24.875H24.875C24.1457 24.875 23.4462 25.1647 22.9305 25.6805C22.4147 26.1962 22.125 26.8957 22.125 27.625V52.4816C22.1259 53.1824 22.4047 53.8542 22.9002 54.3498C23.3958 54.8453 24.0676 55.1241 24.7684 55.125H55.278C55.9665 55.1241 56.6265 54.8502 57.1133 54.3634C57.6002 53.8765 57.8741 53.2165 57.875 52.528V33.125C57.875 32.3957 57.5853 31.6962 57.0695 31.1805C56.5538 30.6647 55.8543 30.375 55.125 30.375ZM24.875 27.625H33.9311L36.6811 30.375H24.875V27.625ZM55.125 52.375H24.875V33.125H55.125V52.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.e15505b54da4e010c9ea9d27d1200c50.svg";
export { ForwardRef as ReactComponent };